import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-3">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={4} className="text-center text-md-start mb-2 mb-md-0">
            <small className="text-muted copyright">
              © {currentYear} Innovatix Technology Partners. All rights reserved.
            </small>
          </Col>
          <Col xs={12} md={4} className="text-center"><small className='text-muted'>Continuum learns continuously!</small></Col>
          <Col xs={12} md={4} className="text-center text-md-end">
            <div className="footer-links">
              <Link 
                to="/privacy-policy" 
                className="footer-link text-decoration-none text-muted me-2"
              >
                Privacy Policy
              </Link>
              <span className="text-muted me-2">|</span>
              <Link 
                to="/terms-of-service" 
                className="footer-link text-decoration-none text-muted"
              >
                Terms of Service
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;